import { render, staticRenderFns } from "./ListConsignes.vue?vue&type=template&id=abf40680&scoped=true&"
import script from "./ListConsignes.vue?vue&type=script&lang=ts&"
export * from "./ListConsignes.vue?vue&type=script&lang=ts&"
import style0 from "./ListConsignes.vue?vue&type=style&index=0&id=abf40680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf40680",
  null
  
)

export default component.exports